import * as ng from 'angular';
import { BaseUrlService } from '../../../services/base-url.service';
import { ArchiSmallServices } from '../../../services/archismall.service';

class SubscriptionExpirationController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'ArchiSmallServices',
        'store',
        'BaseUrlService'
    ];
    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private $http: ng.IHttpService,
        private configuration: any,
        private ArchiSmallServices: ArchiSmallServices,
        private store: ng.a0.storage.IStoreService,
        private _baseService: BaseUrlService
    ) {

        ArchiSmallServices.getUser($rootScope.currentUser().sub)
            .then((response: any) => {
                $rootScope.user = response;
                store.set('user', response);
                // rimuovere ArchiSmallServices.setBaseUrl(response.accountData.serverInstance);
                // rimuovere _baseService.setBaseUrl(response.accountData.serverInstance);
            }, (error) => {
                $rootScope.alert('error', error);
            });

        $scope.closeAlert = (index) => {
            store.set('showAlert', false);
        };
    }
}

export const SubscriptionExpirationComponent: ng.IComponentOptions = {
    template: require('./subscription-expiration.html'),
    controller: SubscriptionExpirationController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/unsubscription/subscription-expiration/subscription-expiration.ts